import React, { useState } from "react";
import { Menu, X, Phone, Mail } from "lucide-react";
import { Button } from "./ui/button";
import { EnquiryModal } from "./EnquiryModal";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm">
      {/* Top bar with contact info */}
      <div className="bg-teal-700 text-white py-2 px-4">
        <div className="container mx-auto flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href="tel:01516775573" className="flex items-center gap-2 hover:text-orange-300 transition-colors">
              <Phone className="h-4 w-4" />
              <span className="hidden sm:inline">0151 677 5573</span>
            </a>
            <a href="mailto:manager@barnstoncourt.com" className="flex items-center gap-2 hover:text-orange-300 transition-colors">
              <Mail className="h-4 w-4" />
              <span className="hidden sm:inline">manager@barnstoncourt.com</span>
            </a>
          </div>
          <div className="text-xs hidden md:block">
            21 Barnston Lane, Moreton, Wirral, CH46 7TN
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="container mx-auto px-4">
        <nav className="flex items-center justify-between py-4">
          {/* Logo - Clickable to scroll to top */}
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex items-center gap-3 cursor-pointer"
            data-testid="header-logo-btn"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_github-pull-8/artifacts/1ub08pix_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2002_38_32%20PM.png" 
              alt="Cozee Care" 
              className="h-20 w-20 object-contain"
            />
            <div className="text-left">
              <div className="font-bold text-xl text-teal-700">Barnston Court</div>
              <div className="text-sm text-gray-600">Nursing Home</div>
            </div>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            <button onClick={() => scrollToSection("about")} className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              About
            </button>
            <button onClick={() => scrollToSection("bed-availability")} className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Availability
            </button>
            <button onClick={() => scrollToSection("care-types")} className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Care Services
            </button>
            <button onClick={() => scrollToSection("reviews-rating")} className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Reviews
            </button>
            <button onClick={() => scrollToSection("careers")} className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              Careers
            </button>
            <button onClick={() => scrollToSection("faq")} className="text-gray-700 hover:text-teal-700 transition-colors font-medium text-sm">
              FAQ
            </button>
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button 
              onClick={() => setIsModalOpen(true)}
              data-testid="header-book-visit-btn"
              className="bg-orange-500 hover:bg-orange-600 text-white"
            >
              Book a Visit Today
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden pb-4 space-y-3">
            <button onClick={() => scrollToSection("about")} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 rounded transition-colors">
              About
            </button>
            <button onClick={() => scrollToSection("bed-availability")} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 rounded transition-colors">
              Bed Availability
            </button>
            <button onClick={() => scrollToSection("care-types")} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 rounded transition-colors">
              Care Services
            </button>
            <button onClick={() => scrollToSection("reviews-rating")} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 rounded transition-colors">
              Reviews
            </button>
            <button onClick={() => scrollToSection("careers")} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 rounded transition-colors">
              Careers
            </button>
            <button onClick={() => scrollToSection("faq")} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-teal-50 rounded transition-colors">
              FAQ
            </button>
            <div className="px-4 pt-2">
              <Button 
                onClick={() => {
                  setMobileMenuOpen(false);
                  setIsModalOpen(true);
                }}
                data-testid="mobile-book-visit-btn"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white"
              >
                Book a Visit Today
              </Button>
            </div>
          </div>
        )}
      </div>

      {/* Enquiry Modal */}
      <EnquiryModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        enquiryType="visit"
      />
    </header>
  );
};
